const constants = require('@/util/constants')
require('./config')

/**
 * 百度通用翻译api
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function baiduTranslate(mid, q, from, to, successcb, failedcb) {
    axios.get('/visitor/api/language/baidu/translate', {
        params: {
            'mid': mid,
            'q': q,
            'from': from,
            'to': to
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}

/**
 * 百度语种识别api
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function baiduRecognize(mid, q, successcb, failedcb) {
    axios.get('/visitor/api/language/baidu/recognize', {
        params: {
            'mid': mid,
            'q': q
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
